import { LenderName, PaymentMethodType } from '@nemuru-eng/js-api-client';

export const LENDERS_TO_HIDE = [LenderName.ASTARA, LenderName.UPF, LenderName.NEMURU];

export const EXCLUDED_IBERIA_MERCHANT_IDS = [
  'cf35b246-7432-4de1-9dea-b2bda4e1ad5b', // IBERIA LAE PROD
  '29ae85aa-0441-43f2-825b-899a38c3dad1', // IBERIA STG
  'd9238011-1313-46ec-9fd4-d0d064682113', // IBERIA DEV
];

export const IBERIA_CARDS_VISIBLE_LENDERS = [
  LenderName.FLOA,
  LenderName.PEPPER,
  LenderName.APLAZAME,
  LenderName.SEQURA,
];

export const PRICINGLESS_PAYMENT_METHODS: PaymentMethodType[] = [
  PaymentMethodType.A2A_PAYMENT,
  PaymentMethodType.CARD_PAYMENT,
];
